// extracted by mini-css-extract-plugin
module.exports = {"infoWrap":"floor-detail_infoWrap_aR0xT","infoItem":"floor-detail_infoItem_1h7r4","label":"floor-detail_label_31qIV","value":"floor-detail_value_2_Nyr"};